const words = [
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
  '+',
  'INNOVATORS',
  '+',
  'RESEARCHERS',
  '+',
  'ENGINEERS',
  '+',
  'GENETICISTS',
  '+',
  'PIONEERS',
  '+',
  'VISIONARIES',
  '+',
  'CREATORS',
  '+',
  'SCIENTISTS',
  '+',
  'TECHNOLOGISTS',
  '+',
  'BIOLOGISTS',
  '+',
  'EXPLORERS',
  '+',
  'DESIGNERS',
  '+',
  'DEVELOPERS',
  '+',
  'LEADERS',
  '+',
  'INNOVATORS',
  '+',
  'THINKERS',
  '+',
  'DREAMERS',
  '+',
  'SCHOLARS',
  '+',
  'FUTURISTS',
  '+',
  'TRAILBLAZERS',
];

export default words;
